/* tslint:disabled */
/* eslint-disable */
/**
 * Guardrails
 * The service allows to get create guardrails, update, delete, add to folder, remove from folder them. Also it allows to list, create, update and delete folders.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  Meta,
  OptimisticUpdate,
  QueryConfig,
  QueryKey,
  QueryOptions,
  Rollback,
  TransformStrategy,
  Update
} from 'redux-query'
export {
  BlobApiResponse,
  JSONApiResponse,
  makeRequestWrapper,
  TextApiResponse,
  VoidApiResponse
} from '../'
export type { APIResponse } from '../'

export type RequestConfig<T> = QueryConfig<T>

export interface TypedQueryConfig<TState, TBody> {
  basePath?: string
  force?: boolean
  meta?: Meta
  options?: QueryOptions
  queryKey?: QueryKey
  update?: Update<TState>
  optimisticUpdate?: OptimisticUpdate<TState>
  retry?: boolean
  rollback?: Rollback<TState>
  transform?: TransformStrategy<TState, TBody>
}

export class RequiredError extends Error {
  name: 'RequiredError' = 'RequiredError'
  constructor(public field: string, msg?: string) {
    super(msg)
  }
}

export const COLLECTION_FORMATS = {
  csv: ',',
  ssv: ' ',
  tsv: '\t',
  pipes: '|'
}

export type ModelPropertyNaming =
  | 'camelCase'
  | 'snake_case'
  | 'PascalCase'
  | 'original'
export interface Consume {
  contentType: string
}
export type HTTPHeaders = { [key: string]: string }
export type Json = any
export type HTTPMethod =
  | 'GET'
  | 'POST'
  | 'PUT'
  | 'PATCH'
  | 'DELETE'
  | 'OPTIONS'
  | 'HEAD'
export type HTTPQuery = {
  [key: string]:
    | string
    | number
    | null
    | boolean
    | Array<string | number | null | boolean>
    | HTTPQuery
}
export type HTTPBody = Json | FormData | URLSearchParams

export function exists(json: any, key: string) {
  const value = json[key]
  return value !== null && value !== undefined
}

export function mapValues(data: any, fn: (item: any) => any) {
  return Object.keys(data).reduce(
    (acc, key) => ({ ...acc, [key]: fn(data[key]) }),
    {}
  )
}
